/**
 * A one-line channel from the pointer handlers to the wire layer.
 *
 * A drag moves nodes on every frame and the wires have to follow, but nothing about the SET
 * of wires changes while it does — only their shape. So the drag says "repaint" and the wire
 * layer rewrites its `d` attributes in place: no React render, no reflow, no reconciliation
 * of three hundred paths per mouse movement.
 *
 * A module-level callback rather than context or a store field, because both ends are
 * outside React's data flow by design — one is a `pointermove` handler, the other is an
 * imperative DOM write. Putting a per-frame signal into the store would be routing it back
 * through exactly the machinery it exists to avoid.
 */

type Repaint = () => void;

let repaint: Repaint | null = null;

/** The wire layer registers itself. Returns the unsubscribe its effect cleans up with. */
export function onWireRepaint(fn: Repaint): () => void {
  repaint = fn;
  return () => {
    if (repaint === fn) repaint = null;
  };
}

/** Redraw the wires from current state. Safe before the layer has mounted. */
export function repaintWires(): void {
  repaint?.();
}
